export type HotRankItem = {
  rank: number;
  title: string;
  summary: string;
  heat: string;
  comments: number;
  tag: string;
  time: string;
};

export type LatestCard = {
  id: string;
  title: string;
  summary: string;
  tag: string;
  time: string;
  comments: number;
  views: string;
  badge: string;
  image: string;
};

export type CommentItem = {
  id: string;
  name: string;
  initials: string;
  text: string;
  time: string;
  likes: number;
  replies: number;
  scene: string;
};

export type TopicItem = {
  id: string;
  name: string;
  count: string;
  hot: boolean;
};

export type StatItem = {
  id: string;
  label: string;
  value: string;
  unit: string;
  delta: string;
};

export const navItems = [
  { label: "首页", anchor: "top" },
  { label: "最新更新", anchor: "latest" },
  { label: "今日热传", anchor: "ranking" },
  { label: "刷屏榜", anchor: "board" },
  { label: "吃瓜现场", anchor: "scene" },
  { label: "话题专区", anchor: "topic" },
];

export const liveTickerItems = [
  "刚刚补档 · 颁奖礼后台同框视频",
  "热传中 · 舞台直拍机位完整版",
  "今天刚出 · 采访现场这段回应",
  "正在刷屏 · 综艺名场面未剪片段",
  "新出 · 红毯造型生图合集",
  "更新 · 剧组路透当天画面",
  "热传中 · 直播切片被反复转发",
  "刚补 · 后台花絮彩蛋第二段",
];

export const heroFeature = {
  badge: "今天刚出",
  time: "12 分钟前更新",
  title: "颁奖礼后台同框这段，刚出就被反复转发",
  description:
    "现场机位刚放出的完整画面，两人同框不到十秒却全程没剪，弹幕区已经把每一帧都拆开看了一遍。这条属于典型“刚出就热传”的更新，先存着，晚点回看还能对上后续动向。",
  primaryCta: "立即回看刚出画面",
  secondaryCta: "加入更新提醒",
  meta: ["更新于 12 分钟前", "已补 3 段画面", "热度持续上升"],
  stats: [
    { value: "18.6万", label: "刚出播放" },
    { value: "4,281", label: "现场评论" },
    { value: "9", label: "相关补档" },
  ],
};

export const hotRankItems: HotRankItem[] = [
  {
    rank: 1,
    title: "颁奖礼后台同框这段，刚出就被反复转发",
    summary: "完整机位无剪辑，弹幕把每一帧都拆开看",
    heat: "98.7万",
    comments: 4281,
    tag: "今天刚出",
    time: "12 分钟前",
  },
  {
    rank: 2,
    title: "舞台直拍机位完整版，第二段走位被放大",
    summary: "导播切走的那两秒，直拍机位原封不动留着",
    heat: "76.2万",
    comments: 3106,
    tag: "热传中",
    time: "34 分钟前",
  },
  {
    rank: 3,
    title: "采访现场这段回应，语气停顿被反复回放",
    summary: "一句话中间停了半拍，评论区各有各的读法",
    heat: "63.5万",
    comments: 2688,
    tag: "刚补档",
    time: "1 小时前",
  },
  {
    rank: 4,
    title: "综艺名场面未剪片段，正片里没看到的那段",
    summary: "正片外流出的加长版，多了约四十秒对话",
    heat: "51.8万",
    comments: 1942,
    tag: "正在刷屏",
    time: "2 小时前",
  },
  {
    rank: 5,
    title: "红毯造型生图合集，现场灯下的真实状态",
    summary: "无滤镜生图九张，夜景灯效和通稿差别不小",
    heat: "44.1万",
    comments: 1533,
    tag: "新出",
    time: "3 小时前",
  },
  {
    rank: 6,
    title: "剧组路透当天画面，收工后这段被补上",
    summary: "补的是收工之后的画面，和早上那条能接上",
    heat: "38.9万",
    comments: 1210,
    tag: "更新",
    time: "4 小时前",
  },
  {
    rank: 7,
    title: "直播切片被反复转发，主播当场接词那一下",
    summary: "切片只有十几秒，但评论区已经吵了两百条",
    heat: "31.4万",
    comments: 986,
    tag: "热传中",
    time: "5 小时前",
  },
  {
    rank: 8,
    title: "后台花絮彩蛋第二段，正片之外多出来的镜头",
    summary: "彩蛋被拆成两批放出，第二批明显更完整",
    heat: "26.7万",
    comments: 742,
    tag: "刚补",
    time: "6 小时前",
  },
];

export const latestCards: LatestCard[] = [
  {
    id: "l1",
    title: "颁奖礼后台同框这段，完整机位刚放出",
    summary:
      "现场机位无剪辑版本上线，两人同框不到十秒，评论区已经把前后动线理了一遍。属于刚出就热传的一类，建议先存，晚点还能对上后续。",
    tag: "今天刚出",
    time: "12 分钟前",
    comments: 4281,
    views: "18.6万",
    badge: "新",
    image:
      "https://readdy.ai/api/search-image?query=Artistic%20dramatic%20stage%20backstage%20scene%20with%20warm%20amber%20spotlights%20and%20deep%20red%20curtain%2C%20silhouette%20figures%20in%20motion%2C%20filmic%20moody%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20high%20contrast%2C%20no%20text&width=900&height=560&seq=hl-video-card-01&orientation=landscape",
  },
  {
    id: "l2",
    title: "舞台直拍机位完整版，导播切走的那两秒原样保留",
    summary:
      "直拍机位从头到尾没剪，第二段走位被放大之后，很多人回头又看了一遍。画质一般但角度最完整，属于需要慢放才看得清的一类。",
    tag: "热传中",
    time: "34 分钟前",
    comments: 3106,
    views: "12.4万",
    badge: "热",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20concert%20stage%20with%20glowing%20warm%20golden%20light%20beams%20and%20haze%2C%20motion%20blur%20dancers%20in%20distance%2C%20cinematic%20dark%20background%2C%20warm%20orange%20and%20amber%20tones%2C%20editorial%20photography%20style%20no%20text&width=900&height=560&seq=hl-video-card-02&orientation=landscape",
  },
  {
    id: "l3",
    title: "采访现场这段回应，中间那半拍停顿被反复回放",
    summary:
      "一句话说完之前停了半拍，评论区各有各的读法。音频已经过降噪处理，戴上耳机听会更清楚一点，配合原速和慢速两版一起看。",
    tag: "刚补档",
    time: "1 小时前",
    comments: 2688,
    views: "9.8万",
    badge: "补",
    image:
      "https://readdy.ai/api/search-image?query=Artistic%20studio%20interview%20setting%20with%20soft%20warm%20window%20light%2C%20empty%20chair%20and%20microphone%20on%20table%2C%20muted%20beige%20and%20terracotta%20tones%2C%20minimal%20editorial%20photography%2C%20calm%20composition%20no%20text&width=900&height=560&seq=hl-video-card-03&orientation=landscape",
  },
  {
    id: "l4",
    title: "综艺名场面未剪片段，正片里没有的那四十秒",
    summary:
      "加长版比正片多出约四十秒对话，节奏明显不一样。把两版并排看会发现衔接点被处理过，这也是它今天被反复转发的原因。",
    tag: "正在刷屏",
    time: "2 小时前",
    comments: 1942,
    views: "7.6万",
    badge: "新",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20variety%20show%20studio%20set%20with%20colorful%20retro%20props%20and%20amber%20lighting%2C%20empty%20sofa%20and%20cameras%2C%20playful%20editorial%20photography%2C%20soft%20shadows%2C%20muted%20warm%20palette%20no%20text&width=900&height=560&seq=hl-video-card-04&orientation=landscape",
  },
  {
    id: "l5",
    title: "红毯造型生图合集，现场灯下的真实状态",
    summary:
      "无滤镜生图九张，夜景灯效下的状态和通稿差得不小。选了几张角度相近的放在一起对比，方便看造型本身而不是打光。",
    tag: "新出",
    time: "3 小时前",
    comments: 1533,
    views: "6.1万",
    badge: "热",
    image:
      "https://readdy.ai/api/search-image?query=Artistic%20red%20carpet%20arrival%20scene%20at%20night%20with%20deep%20crimson%20carpet%20and%20warm%20gold%20bokeh%20lights%2C%20elegant%20silhouette%20in%20distance%2C%20cinematic%20editorial%20photography%2C%20rich%20contrast%20no%20text&width=900&height=560&seq=hl-video-card-05&orientation=landscape",
  },
  {
    id: "l6",
    title: "剧组路透当天画面，收工之后这段被补上",
    summary:
      "补的是收工之后的画面，跟早上那条路透正好能接上。当天光线偏冷，片段已经做过基础校正，重点在人物动线而不是画面质量。",
    tag: "更新",
    time: "4 小时前",
    comments: 1210,
    views: "5.3万",
    badge: "补",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20outdoor%20film%20set%20alley%20at%20dusk%20with%20warm%20street%20lamps%20and%20equipment%20crates%2C%20cinematic%20teal%20and%20amber%20contrast%2C%20atmospheric%20fog%2C%20editorial%20photography%20no%20text&width=900&height=560&seq=hl-video-card-06&orientation=landscape",
  },
];

export const commentItems: CommentItem[] = [
  {
    id: "c1",
    name: "蹲后续的瓜农",
    initials: "瓜",
    text: "刚出那段我看了三遍，第二遍开慢放才发现走位是提前对过的，不是临场。",
    time: "8 分钟前",
    likes: 1284,
    replies: 96,
    scene: "颁奖礼后台同框",
  },
  {
    id: "c2",
    name: "只看原速",
    initials: "原",
    text: "建议先看原速再看慢速，直接上慢速容易被带节奏，自己判断比较稳。",
    time: "15 分钟前",
    likes: 867,
    replies: 54,
    scene: "舞台直拍完整版",
  },
  {
    id: "c3",
    name: "耳机已戴好",
    initials: "耳",
    text: "降噪版确实清楚很多，那半拍停顿的地方不用拉进度条也能听出来。",
    time: "22 分钟前",
    likes: 642,
    replies: 38,
    scene: "采访现场回应",
  },
  {
    id: "c4",
    name: "并排对比中",
    initials: "并",
    text: "把正片和未剪片段并排之后，衔接点那一下太明显了，难怪今天一直在转。",
    time: "41 分钟前",
    likes: 519,
    replies: 71,
    scene: "综艺名场面未剪",
  },
  {
    id: "c5",
    name: "生图党",
    initials: "生",
    text: "生图这套角度选得挺好，不看打光只看造型的话，现场状态其实很稳。",
    time: "1 小时前",
    likes: 388,
    replies: 25,
    scene: "红毯造型生图",
  },
];

export const topicItems: TopicItem[] = [
  { id: "t1", name: "今天刚出", count: "128 条更新", hot: true },
  { id: "t2", name: "热传中", count: "96 条更新", hot: true },
  { id: "t3", name: "综艺名场面", count: "74 条更新", hot: false },
  { id: "t4", name: "舞台直拍", count: "61 条更新", hot: true },
  { id: "t5", name: "采访回放", count: "53 条更新", hot: false },
  { id: "t6", name: "红毯生图", count: "47 条更新", hot: false },
  { id: "t7", name: "剧组路透", count: "39 条更新", hot: false },
  { id: "t8", name: "后台彩蛋", count: "32 条更新", hot: false },
];

export const statItems: StatItem[] = [
  { id: "s1", label: "今日新增更新", value: "128", unit: "条", delta: "较昨日 +22" },
  { id: "s2", label: "正在热传", value: "36", unit: "条", delta: "持续上升中" },
  { id: "s3", label: "刚刚补档", value: "19", unit: "条", delta: "近 1 小时" },
  { id: "s4", label: "现场评论", value: "2.4万", unit: "条", delta: "互动更醒目" },
];

export const footerColumns = [
  {
    title: "快速浏览",
    links: ["最新更新", "今日热传", "刷屏榜", "吃瓜现场"],
  },
  {
    title: "内容专区",
    links: ["综艺名场面", "舞台直拍", "采访回放", "后台彩蛋"],
  },
  {
    title: "关于本站",
    links: ["更新说明", "免责声明", "内容纠错", "联系我们"],
  },
];